import type { SVGProps } from 'react';

export const AnalyticsIcon = ({
  fill,
  size = 24,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M9 12H7V17H9V12Z" fill={fill ?? '#696F88'} />
    <path d="M15 7H17V17H15V7Z" fill={fill ?? '#696F88'} />
    <path d="M13 14H11V17H13V14Z" fill={fill ?? '#696F88'} />
    <path d="M11 10H13V12H11V10Z" fill={fill ?? '#696F88'} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z"
      fill={fill ?? '#696F88'}
    />
  </svg>
);
